import React, { useState } from 'react';
import styled from 'styled-components';
import { GhostPartner, setGhostPartner } from '../utils/partnerUser';

const StyledDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10001;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 8px;
  font-size: 12px;
  color: white;
  background-color: rgba(255, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  button {
    font-size: 12px;
    text-decoration: underline;
    cursor: pointer;
    background: transparent;
    color: white;
    border: none;
  }
  .error {
    color: #ffd6d6;
  }
`;

const PARTNER_LABEL: Record<GhostPartner, string> = { cn: 'CN', bb: 'BB' };

const handleExit = () => {
  sessionStorage.removeItem('trueimpact.ghostedUsername');
  setGhostPartner(null);
  window.location.href = '/';
};

// Keep ghosting the same user, just drop the partner view
const handleGhostAsTi = () => {
  setGhostPartner(null);
  window.location.href = '/';
};

const PartnerGhostBanner: React.FC<{ partner: GhostPartner; error?: string }> = ({
  partner,
  error,
}) => {
  const [show, setShow] = useState(true);
  if (!show) return null;

  return (
    <StyledDiv>
      <button onClick={() => setShow(false)}>Close</button>
      <strong>
        Ghosting as {PARTNER_LABEL[partner]} user:{' '}
        {sessionStorage.getItem('trueimpact.ghostedUsername')}
      </strong>
      {error && <span className="error">{error}</span>}
      <span>
        <button onClick={handleGhostAsTi}>Ghost as TI user</button>
        <button onClick={handleExit}>Back to Super Admin account</button>
      </span>
    </StyledDiv>
  );
};

export default PartnerGhostBanner;
